import React from 'react';
import { Button } from './ui/Button';

type SuccessStateProps = {
  icon?: string;
  title: string;
  message: string;
  onButtonClick: () => void;
};

export const SuccessState: React.FC<SuccessStateProps> = ({
  icon = '/successful.svg',
  title,
  message,
  onButtonClick,
}) => {
  return (
    <div className="w-full flex flex-col items-center justify-center gap-8 py-8">
      <img src={icon} alt="Success" style={{ width: '80px', height: '80px' }} />
      <div className="flex flex-col items-center gap-4">
        <h3 className="text-2xl font-semibold text-black text-center">{title}</h3>
        <p className="text-sm text-gray-700 text-center max-w-md leading-relaxed">{message}</p>
      </div>
      <Button onClick={onButtonClick} variant="primary">
        "Ok"
      </Button>
    </div>
  );
};
